import { ReactNode, Suspense } from 'react';
import { Provider } from 'react-redux';
import { store } from '@/store/index';
import { MantineProvider } from './MantineProvider';
import { QueryProvider } from './QueryProvider';
import { ContentProvider } from './ContentProvider';
import { Loading } from '@/components/ui/loading/Loading';

export const AppProviders = ({ children }: { children: ReactNode }) => {
	return (
		<Provider store={store}>
			<QueryProvider>
				<ContentProvider>
					<MantineProvider>
						<Suspense fallback={<Loading />}>{children}</Suspense>
					</MantineProvider>
				</ContentProvider>
			</QueryProvider>
		</Provider>
	);
};
